import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router";

import { ERequestState, MiscellaneousRequestApi, MiscellaneousRequestDto } from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { DrupalMiscellaneousRequestForm } from "./DrupalMiscellaneousRequestForm";

export interface IDrupalMiscellaneousRequestPageProps {}

export const DrupalMiscellaneousRequestPage: React.FunctionComponent<IDrupalMiscellaneousRequestPageProps> = () => {
  const { id } = useParams<{ id: string }>();
  const miscellaneousRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(MiscellaneousRequestApi);
  // TODO-CRR : saving is used, but not saveItem???
  const { data, loading, saving } = useCrudApi<MiscellaneousRequestDto>(
    React.useMemo(
      () => ({
        getApiFn: (apiId = miscellaneousRequestId) =>
          apiId > 0
            ? api.get(apiId)
            : new MiscellaneousRequestDto({
                miscellaneousRequestId: apiId,
              }).toJSON(),
        saveApiFn: (d: MiscellaneousRequestDto) => api.save(d),
        onSavedRoute: (d) =>
          d.request.status === ERequestState.BILLED
            ? `${EDrupalRoutes.miscellaneousRequest}/${d.miscellaneousRequestId}`
            : EDrupalRoutes.requestList,
        deleteApiFn: () => {},
      }),
      [api, miscellaneousRequestId]
    ),
    [miscellaneousRequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet title={`${t(ETLCodes.Payment)}: ${t(ETLCodes.MiscellaneousRequest)}`}>
        <div>
          {saving ? (
            <Spinner />
          ) : (
            <DrupalRequestResume
              requestForm={
                <DrupalMiscellaneousRequestForm
                  miscellaneousRequestId={miscellaneousRequestId}
                  initialdata={data}
                  loading={saving}
                />
              }
              requestDto={data?.request}
              bill={null}
            />
          )}
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
